import bridge from '@/utils/bridge'

// 去登录页面
export function toAppLogin() {
  return bridge.callHandler('halo_fun_page', { goto_page: 'halo_page_login' })
}

// 去聊天页面
export function toAppChat() {
  return bridge.callHandler('halo_fun_page', { goto_page: 'halo_page_chat' })
}

export function toAppService(id) {
  return bridge.callHandler('halo_fun_page', { goto_page: 'halo_page_productdetail', goto_page_params: { id } })
}

// 通知收藏修改
export function notifyCollect() {
  return bridge.callHandler('halo_fun_page', { send_event: 'halo_event_collection_change' })
}
